var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyHomeCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 48,
    width: 856,
    height: 905
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 48H928V952.432H72V48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.573 456.719C277.203 537.354 334.802 617.984 392.396 721.656C661.177 214.818 987.552 -15.5676 918.437 65.0678C699.573 345.365 549.823 629.505 403.917 952.042C319.443 798.453 211.932 594.948 81.3801 552.714C42.9842 514.313 135.135 422.162 196.573 456.719Z",
    fill: "#26A282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyHomeCheckIcon);
export default __webpack_public_path__ + "static/media/HappyHome_CheckIcon.2a28b5e032a63dedb587df7520a10bb4.svg";
export { ForwardRef as ReactComponent };